<script lang="ts">
    import lang from '../../lang/language';
    import {
        formatMoney,
        getNotAvailable,
        getTime,
        getType,
    } from '../../helpers/common';
    import AddToWishlistButton from '../../shared_components/AddToWishlistButton.svelte';
    import { getLanguage, getUrlParam } from '../../helpers/url';
    import { currentLangIsJapanese } from '../../helpers/url';
    import { onMount } from 'svelte';
    import V3Factory from '../../helpers/V3';
    import CardSkeleton from '../services/CardSkeleton.svelte';
    import { date, night, guest } from '../../store/search';
    import { children, exclude_internal_props } from 'svelte/internal';
    import ImageSlider from '../../shared_components/ImageSlider.svelte';
    import ImagePreview from '../../shared_components/ImagePreview.svelte';
    import { openModal } from 'svelte-modals';
    import RequestModal from '../../shared_components/modals/RequestModal.svelte';
    import App from '../../App.svelte';
    import { OAshortname, shortname } from '../../helpers/consts';

    export let service: any;
    export let onRequest: boolean;
    export let selectedService;

    let bookingQuote;
    let isOpenModal = false;

    let startTimeIndex = 0;

    let isLoading = true;

    let childrenClass = '';

    let extras = [];

    let request;

    let singlePrice = 0;

    function openRequestModal() {
        openModal(RequestModal, {
            request: {
                ProductId: service.Id,
                ProductName: service.Name,
                ProductExtras: extras,
                ProductCode: service.Code,
                Price: bookingQuote.Configurations[0].Quotes[startTimeIndex]
                    .TotalPrice,
                CurrentCurrency: 'JPY',
                Language: getLanguage(),
                IndustryCategoryGroup: getType(service.Type),
                CommencementDate:
                    bookingQuote.Configurations[0].Quotes[startTimeIndex]
                        .Commence,
                ConcludeDate:
                    bookingQuote.Configurations[0].Quotes[startTimeIndex]
                        .Conclude,
                Duration: service.Type === 0 ? $night : null,
                Adults: $guest,
                SupplierName: selectedService.Name,
                SupplierAddress: selectedService.Address,
                SupplierEmail: selectedService.PublicEmail,
                SupplierPhone: selectedService.Phone,
                SupplierWebsite: selectedService.Website,
                SupplierId: selectedService.Id,
                SupplierCode: selectedService.Code,
            },
        });
    }

    const readMore = () => {
        if (childrenClass === '') {
            childrenClass = 'children';
        } else {
            childrenClass = '';
        }
    };

    const onQuantityChange = () => {
        bookingQuote.Configurations[0].Pax.Adults = $guest;
    };

    onMount(async () => {
        isLoading = true;
        request = {
            CurrentCurrency: 'JPY',
            Language: getLanguage(),
            AdCampaignCode: '',
            IncludeCampaigns: false,
            IncludeExtras: true,
            IndustryCategoryGroup: service.Type,
            CommencementDate: $date,
            Duration: service.Type === 0 ? $night : null,
            Configurations: [
                {
                    Id: '',
                    ProductId: service.Id,
                    Pax: {
                        Adults: $guest,
                        Children: 0,
                        Seniors: 0,
                    },
                },
            ],
        };
        const { getBooking } = V3Factory();
        bookingQuote = await getBooking(
            request,
            getUrlParam('on_req') === 'true' ? OAshortname : shortname
        );

        if (
            bookingQuote &&
            bookingQuote.Configurations[0].Quotes &&
            bookingQuote.Configurations[0].Quotes[startTimeIndex].TotalPrice
        ) {
            singlePrice =
                bookingQuote.Configurations[0].Quotes[startTimeIndex]
                    .TotalPrice / $guest;
        }
        isLoading = false;
    });
</script>

{#if !isLoading}
    <div class="card-wrapper">
        <div class="product-wrapper">
            <div class="info-wrapper">
                <h4 class="bg-before nara-season font info name pl-15">
                    {service.Name}
                </h4>
                <div class="pl-15">
                    <ImagePreview images={service.Images} />
                </div>

                <div class="info price pl-15">
                    {#if !isLoading}
                        {#if bookingQuote.Configurations[0].Quotes && bookingQuote.Configurations[0].Quotes[startTimeIndex].TotalPrice}
                            {lang.price}: ¥{formatMoney(singlePrice * $guest)}
                        {:else}
                            {getNotAvailable(service.Type)}
                        {/if}
                    {:else}
                        loading..
                    {/if}
                </div>
                {#if service.Type === 3}
                    <div class="pl-15 info quantity">
                        <span style="margin-right:10px">{lang.quantity}: </span>
                        <div class="input-wrapper">
                            <input
                                on:change={onQuantityChange}
                                bind:value={$guest}
                                class="input-field"
                                type="number"
                                min="1"
                                placeholder={lang.quantity}
                            />
                        </div>
                    </div>
                {:else if bookingQuote.Configurations[0].Quotes && bookingQuote.Configurations[0].Quotes.length > 0}
                    <div class="info start-time pl-15">
                        <span class="mb-2" style="margin-right:10px"
                            >{lang.start_time}: {getTime(
                                bookingQuote.Configurations[0].Quotes[0]
                                    .Commence
                            )}, {lang.different_time}</span
                        >

                        <div class="input-wrapper mb-2">
                            <select
                                class="input-field"
                                type="text"
                                bind:value={startTimeIndex}
                            >
                                {#each bookingQuote.Configurations[0].Quotes as quotes, index}
                                    <option value={index}
                                        >{getTime(quotes.Commence)}</option
                                    >
                                {/each}
                            </select>
                        </div>
                    </div>
                {/if}

                {#if bookingQuote.Extras.length > 0 && service.Type != 3 && onRequest}
                    <div class="pl-15">
                        <h6>{lang.extras}</h6>
                        {#each bookingQuote.Extras as extra}
                            <div class="d-flex align-items-center mb-2">
                                <input
                                    type="checkbox"
                                    style="margin-right:10px"
                                    value={JSON.stringify(extra)}
                                    bind:group={extras}
                                />
                                <label style="margin-right:10px"
                                    >{extra.Name}</label
                                >
                                <label style="margin-right:10px"
                                    >¥{formatMoney(extra.TotalCost)}</label
                                >
                            </div>
                        {/each}
                    </div>
                {/if}

                <div class="d-block d-md-none pl-15">
                    {#if bookingQuote.Configurations[0].Quotes}
                        {#if onRequest}
                            <button
                                class="first-button"
                                on:click={openRequestModal}
                                >{lang.request_to_book}</button
                            >
                        {:else}
                            <AddToWishlistButton
                                {service}
                                {bookingQuote}
                                {startTimeIndex}
                                {singlePrice}
                            />
                        {/if}
                    {:else}
                        {getNotAvailable(service.Type)}
                    {/if}
                </div>

                {#if service.Desc.replace(/\s/g, '') !== ''}
                    <div class="info desc pl-15 {childrenClass}">
                        {@html service.Desc}
                    </div>
                    <div class="read-more {childrenClass}">
                        <span on:click={readMore}
                            >{childrenClass === ''
                                ? lang.read_more
                                : lang.read_less}</span
                        >
                    </div>
                {/if}
            </div>

            <div class="col-button d-md-flex d-none">
                {#if bookingQuote.Configurations[0].Quotes}
                    {#if onRequest}
                        <button class="first-button" on:click={openRequestModal}
                            >{lang.request_to_book}</button
                        >
                    {:else}
                        <AddToWishlistButton
                            {service}
                            {bookingQuote}
                            {startTimeIndex}
                            {singlePrice}
                        />
                    {/if}
                {:else}
                    {getNotAvailable(service.Type)}
                {/if}
            </div>
        </div>
    </div>
{:else}
    <CardSkeleton numberOfSkeleton={1} />
{/if}

<style>
    .product-wrapper {
        display: flex;
        justify-content: space-between;
    }

    .info-wrapper {
        display: flex;
        flex: 1;
        flex-direction: column;
        padding-right: 10px;
        width: 100%;
    }

    .read-more {
        display: flex;
        color: red;
        justify-content: start;
        width: 100%;
    }

    .read-more span {
        text-decoration: underline;
        cursor: pointer;
    }

    .read-more.children:before {
        content: '-';
        margin-right: 10px;
    }

    .read-more:before {
        content: '+';
        margin-right: 10px;
    }
    .pl-15 {
        padding-left: 15px;
    }

    .info.price {
        font-size: 1.3rem;
        font-weight: bold;
    }

    .info.start-time {
        height: auto;
    }
    .info.name {
        position: relative;
    }

    .info.start-time {
        display: flex;
        align-items: center;
        margin-right: 10px;
    }

    @media screen and (max-width: 850px) {
        .info.start-time {
            align-items: flex-start;
            flex-direction: column;
        }
    }

    .info.quantity {
        display: flex;
        align-items: center;
    }

    .info.quantity .input-wrapper {
        width: 70px;
    }
    .info.quantity .input-wrapper input {
        padding: 0 10px;
    }

    .input-wrapper {
        width: auto;
        height: auto;
    }

    .info.name:before {
        content: '';
        width: 10px;
        height: 100%;
        position: absolute;
        left: 0;
    }
    :global(.info.desc.children) {
        -webkit-line-clamp: inherit;
        height: auto;
    }

    :global(.info.rating) {
        background-image: url('../icons/rating.png');
        background-size: 15px;
        background-position: left center;
        padding-left: 15px;
        background-repeat: no-repeat;
    }

    .col-button {
        display: flex;
        border-left: 1px solid gray;
        justify-content: center;
        width: auto;
        min-width: 150px;
    }
</style>
